import { db, storage, functions } from '@/firebase';
import { randomString } from '@/utils/utils.js';

export default {
  getNegocios({ commit }) {
    let devolver = [];
    let negociosGest = [];
    var refNeg = db.collection('negocios');
    return refNeg
      .get()
      .then((res) => {
        res.forEach((doc) => {
          let aux = doc.data();
          aux.id = doc.id;
          devolver.push(aux);
          let aux_gest = {
            value: doc.id,
            text: aux.nombre,
          };
          negociosGest.push(aux_gest);
        });
        commit('app/setNegociosGestArray', negociosGest, { root: true });
        return devolver;
      })
      .then((r) => {
        var actionsSecreto = r.map(function (item) {
          return refNeg
            .doc(item.id)
            .collection('secreto')
            .doc('apikey')
            .get()
            .then((r2) => {
              if (r2.exists) {
                item.secreto = r2.data();
              }
              return item;
            });
        });
        return Promise.all(actionsSecreto);
      })
      .then((res) => {
        var actions = res.map(function (item) {
          var storageRef = storage.ref('imagenes/negocios/' + item.id + '.jpg');
          var storageRef2 = storage.ref(
            'imagenes/negocios/' + item.id + '_listado.jpg'
          );
          var p1 = storageRef
            .getDownloadURL()
            .then((r) => {
              item.imagen = r;
              return item;
            })
            .catch((e) => {
              item.imagen = false;
              return item;
            });
          var p2 = storageRef2
            .getDownloadURL()
            .then((r) => {
              item.imagenListado = r;
              return item;
            })
            .catch((e) => {
              item.imagenListado = false;
              return item;
            });
          return Promise.all([p1, p2]).then((r) => {
            return item;
          });
        });
        return Promise.all(actions)
          .then((r) => {
            commit('setNegocios', r);
          })
          .catch((e) => {
            console.log(e);
          });
      });
  },
  getNegocioBoss({ commit, state, rootState }) {
    // carga el negoci para los perfiles boss_restaurante, boss_negocio, secretaria y marketing
    const negocio = rootState.app.negocioGest;
    var refNeg = db.collection('negocios').doc(negocio);
    return refNeg
      .get()
      .then((res) => {
        if (res.exists) {
          return {
            ...res.data(),
            id: res.id,
          };
        }
      })
      .then((res) => {
        var storageRef = storage.ref('imagenes/negocios/' + res.id + '.jpg');
        var storageRef2 = storage.ref(
          'imagenes/negocios/' + res.id + '_listado.jpg'
        );
        var p1 = storageRef
          .getDownloadURL()
          .then((r) => {
            res.imagen = r;
            return res;
          })
          .catch((e) => {
            res.imagen = false;
            return res;
          });
        var p2 = storageRef2
          .getDownloadURL()
          .then((r) => {
            res.imagenListado = r;
            return res;
          })
          .catch((e) => {
            res.imagenListado = false;
            return res;
          });
        return Promise.all([p1, p2]).then(() => {
          commit('app/setNegocioObjGest', res, { root: true });
        });
      });
  },
  getAllRestaurantes({ commit }) {
    var res = [];
    return db
      .collection('restaurantes')
      .get()
      .then((r) => {
        r.forEach((e) => {
          let d = e.data();
          res.push({
            ...d,
            id: e.id,
          });
        });
        commit('app/setRestaurantesArray', res, { root: true });
      });
  },
  addNegocio({}, negocio) {
    let id = negocio.id;
    let imagen = negocio.imagen;
    let imagenListado = negocio.imagenListado;
    delete negocio.id;
    delete negocio.imagen;
    delete negocio.imagenListado;
    if (!negocio.cod) {
      let cod = randomString(6);
      negocio.cod = cod;
    }
    var secreto = {};
    if (negocio.printNode) {
      secreto.keyPrintNode = negocio.keyPrintNode;
      delete negocio.keyPrintNode;
    }
    if (negocio.vromo) {
      secreto.vromoApikey = negocio.vromoApikey;
      delete negocio.vromoApikey;
    }
    let ref = db.collection('negocios').doc(id).set(negocio, { merge: true });
    return ref.then((res) => {
      if (!id) {
        id = res.id;
      }
      var promesas = [];
      if (imagen) {
        var storageRef = storage.ref();
        var ref = storageRef.child('imagenes/negocios/' + id + '.jpg');
        promesas.push(ref.put(imagen));
      }
      if (imagenListado) {
        var storageRef = storage.ref();
        var ref = storageRef.child('imagenes/negocios/' + id + '_listado.jpg');
        promesas.push(ref.put(imagenListado));
      }
      if (Object.keys(secreto).length > 0) {
        let p_secreto = db
          .collection('negocios')
          .doc(id)
          .collection('secreto')
          .doc('apikey')
          .set(secreto, { merge: true });
        promesas.push(p_secreto);
      }
      return Promise.all(promesas);
    });
  },
  deleteNegocio({}, id) {
    return db.collection('negocios').doc(id).delete();
  },
  getClientesNegocioCall({ commit, rootState, rootGetters }) {
    const role = rootGetters['auth/role'];
    var id;
    if (role == 'admin') {
      let negocio = rootGetters['app/negocioGestObj'];
      id = negocio.id;
    } else {
      id = rootState.app.negocioGest;
    }
    var getClientes = functions.httpsCallable('httpNegociosGetClientes');
    return getClientes(id).then((r) => {
      commit('setClientesNegocio', r.data);
    });
  },
  getClientesNegocio({ commit, rootState }) {
    return db
      .collection('negocios')
      .doc(rootState.app.negocioGest)
      .collection('clientes')
      .get()
      .then((r) => {
        commit(
          'setClientesNegocio',
          r.docs.map((c) => {
            return {
              ...c.data(),
              id: c.id,
            };
          })
        );
      });
  },
  initNegocio({ commit }, negocio) {
    return commit('app/setNegocioGest', negocio, { root: true });
  },
  getImpresorasNegocio({ rootGetters, commit }) {
    let negocio = rootGetters['app/negocioGestObj'];
    if (!negocio.printNode) {
      return Promise.reject('No tiene datos PrintNode');
    } else {
      var getList = functions.httpsCallable('httpPrintnodeGetprinters');
      return getList(negocio)
        .then(function (result) {
          commit('setImpresoras', result.data);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  },
  getOrdenadoresNegocio({ rootGetters, commit }) {
    let negocio = rootGetters['app/negocioGestObj'];
    if (!negocio.printNode) {
      return Promise.reject('No tiene datos PrintNode');
    } else {
      var getList = functions.httpsCallable('httpPrintnodeGetComputers');
      return getList(negocio)
        .then(function (result) {
          commit('setComputers', result.data);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  },
  async getRestaurantesNegocio({}, item) {
    var res = [];
    await db
      .collection('restaurantes')
      .where('negocio', '==', item.id)
      .get()
      .then((r) => {
        r.forEach((e) => {
          let d = e.data();
          res.push({
            value: e.id,
            text: d.nombre,
          });
        });
        //return res;
      });
    return res;
  },
  getValueSecretosNegocio({ commit, state, rootState, rootGetters }) {
    let negocioGest = rootGetters['app/negocioGestObj'];
    if (negocioGest.mapeoNeo) {
      //no se consulta en cliente, lo pasamos a servidor
      /*let ref = db.collection('restaurantes').doc(negocioGest.mapeoNeoRestaurante)
                .collection('secreto').doc('neo')
                .get()
                .then((r) => {
                    if (r.exists) {
                        let d = r.data();
                        commit('neo/setDatosNeo', d, { root: true });
                    } else {
                        commit('neo/resetDatosNeo', {}, { root: true });
                    }
                })
                .catch((e) => {
                    console.log(e);
                })*/
    } else {
      commit('neo/resetDatosNeo', {}, { root: true });
    }
  },
  /** Toma los productos Neo que previamente se han volcado a firestore */
  getProductosNeo({ rootState, commit }) {
    let negocioGest = rootState.app.negocioGest;
    return db
      .collection('negocios')
      .doc(negocioGest)
      .collection('secreto')
      .doc('neo')
      .collection('productos')
      .get()
      .then((r) => {
        if (r.size > 0) {
          // console.log(r.data().productos.find(p => p.Codigo == '01018260'))
          commit(
            'neo/setProductosNeo',
            r.docs.map((prd) => prd.data()),
            { root: true }
          );
        }
      })
      .catch((e) => console.log(e));
  },
  //toma los productos neo previamente volcado en cada restaurante
  getProductosNeoRestaurantes({ rootState, commit, dispatch }) {
    var promesas = [];
    let rests = rootState.restaurantes.restaurantesArray;
    rests.forEach((r) => {
      promesas.push(
        db
          .collection('restaurantes')
          .doc(r.id)
          .collection('secreto')
          .doc('neo')
          .get()
          .then((sR) => {
            if (sR.exists) {
              const aux = sR.data().productos;
              if (aux) {
                return {
                  id: r.id,
                  productos: aux,
                };
              } else {
                return {
                  id: r.id,
                  productos: [],
                };
              }
            }
          })
      );
    });
    return Promise.all(promesas)
      .then((r) => {
        commit('neo/setProductosNeoRestauranteTodos', r, { root: true });
      })
      .catch((e) => {
        console.log(e);
      });
  },
  getPedidosNegocio({ rootGetters, commit, dispatch, rootState }) {
    let negocio = rootGetters['app/negocioGestObj'];
    return dispatch('pedidos/setRangoDefecto', {}, { root: true }).then(() => {
      var snap = db
        .collection('pedidos')
        .where('fechaServidor', '>=', rootState.pedidos.diaComprobando1)
        .where('fechaServidor', '<=', rootState.pedidos.diaComprobando2)
        .where('negocio', '==', negocio.id)
        .onSnapshot((snapDoc) => {
          var res = [];
          snapDoc.forEach((e) => {
            res.push(e.data());
          });
          commit('setPedidosArray', res);
          return;
        });
      commit('app/addTiempoReal', snap, { root: true });
    });
  },
  saveEmails({}, payload) {
    return db
      .collection('negocios')
      .doc(payload.id)
      .collection('secreto')
      .doc('emails')
      .set(payload.emails, { merge: true });
  },
  saveFacturacion({}, payload) {
    return db
      .collection('negocios')
      .doc(payload.id)
      .collection('secreto')
      .doc('facturacion')
      .set(payload.facturacion, { merge: true });
  },
  getEmails({}, id) {
    return db
      .collection('negocios')
      .doc(id)
      .collection('secreto')
      .doc('emails')
      .get()
      .then((r) => {
        if (r.exists) {
          return r.data();
        }
      });
  },
  getFacturacion({}, id) {
    return db
      .collection('negocios')
      .doc(id)
      .collection('secreto')
      .doc('facturacion')
      .get()
      .then((r) => {
        if (r.exists) {
          return r.data();
        }
      });
  },
  enlaceStripe({}, id) {
    var getUrl = functions.httpsCallable('httpStripeGetUrlDashboardNegocio');
    return getUrl(id);
  },
  borrarCuentaStripe({}, id) {
    var borrar = functions.httpsCallable('httpStripeBorrarCuentaConnect');
    return borrar(id);
  },
  guardarHooks({ rootState }, hooks) {
    let negocioGest = rootState.app.negocioGest;
    return db
      .collection('negocios')
      .doc(negocioGest)
      .collection('secreto')
      .doc('integraciones')
      .set(
        {
          hooks: hooks,
        },
        { merge: true }
      );
  },
  cargarHooks({ rootState }) {
    let negocioGest = rootState.app.negocioGest;
    return db
      .collection('negocios')
      .doc(negocioGest)
      .collection('secreto')
      .doc('integraciones')
      .get()
      .then((r) => {
        if (r.exists) {
          return r.data().hooks;
        } else {
          return {};
        }
      });
  },
};
